
import periods from "./Periods.js"
export default {
  id : 2,
  title : "OPEX UG Mining",
  link: "/abc/kpi/opex/ugmining",
  template : "pageA",
  i18n : "ABC.OPEX.UGMining",
  layout : {
    upper1 : {
      name : "OPEX",
      type : "radialBar",
      i18n : "ABC.OPEX.BaseValue",
      url: "/Hyperion/Kpi/OPEXUGMining",
      chartData : {
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "KPI_M_k_formatter"
      },
      zoomIn : {
        name : "OPEX Periodic",
        i18n : "ABC.OPEX.Title",
        type : "comparaisonLine",
        url: "/Hyperion/Kpi/PeriodicOPEXUGMining",
        chartData : {
          categories : periods,
          leftDataTitle: "Actual",
          leftDataTitlei18n: "Actual",
          rightDataTitle: "Budget",
          rightDataTitlei18n: "Budget",
          dataFilter: "KPI_M_k_formatter"
        }
      }
    },
    upper2 : {
      name : "OPEX Per Oz",
      i18n : "ABC.OPEX.OPEXPerOz",
      type : "radialBar",
      url: "/Hyperion/Kpi/OPEXUGMiningPerOz",
      chartData : {
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "k_formatter"
      },
      zoomIn : {
        name : "Gold production",
        i18n : "ABC.GoldProduction.Title",
        type : "basicColumn",
        url: "/Hyperion/Kpi/GoldProduction",
        chartData : {
          categories : ["Au"],
          yAxisTitle: "Production (Oz)"
        }
      }
    },
    upper3 : {
      name : "OPEX Per Ton Ore",
      i18n : "ABC.OPEX.OPEXPerTonOre",
      type : "radialBar",
      url: "/Hyperion/Kpi/OPEXUGMiningPerTonOre",
      chartData : {
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "2Digits"
      },
      zoomIn : {
        name : "Ore Tonnes",
        i18n : "ABC.OreTons.Title",
        type : "basicColumn",
        url: "/Hyperion/Kpi/OreTons",
        chartData : {
          categories : ["Ore"],
          yAxisTitle: "Ore (Tons)"
        }
      }
    },
    middle1: {
      name : "OPEX Per Oz",
      i18n : "ABC.OPEX.OPEXPerOz",
      type : "comparaisonLine",
      url: "/Hyperion/Kpi/PeriodicOPEXUGMiningPerOz",
      chartData : {
        categories : periods,
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "2Digits"
      }
    },
    middle2 : {
      name : "OPEX Ton Ore",
      i18n : "ABC.OPEX.OPEXPerTonOre",
      type : "comparaisonLine",
      url: "/Hyperion/Kpi/PeriodicOPEXUGMiningPerTonOre",
      chartData : {
        categories : periods,
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "2Digits"
      }
    },
    below1 : {
      name : "OPEX Mining Development",
      type : "radialBar",
      i18n : "ABC.Development.ShortTitle",
      url: "/Hyperion/Kpi/OPEXUGMiningDevelopment",
      drillTo: "/abc/kpi/opex/ugmining/development",
      chartData : {
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "KPI_M_k_formatter"
      }
    },
    below2 : {
      name : "OPEX Mining Production",
      type : "radialBar",
      i18n : "ABC.Production",
      url: "/Hyperion/Kpi/OPEXUGMiningProduction",
      chartData : {
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "KPI_M_k_formatter"
      }
    },
    below3 : {
      name : "OPEX Mining Services",
      type : "radialBar",
      i18n : "ABC.Services",
      url: "/Hyperion/Kpi/OPEXUGMiningServices",
      chartData : {
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "KPI_M_k_formatter"
      }
    },
    below4 : {
      name : "OPEX Mining Maintenance'",
      type : "radialBar",
      i18n : "ABC.Maintenance",
      url: "/Hyperion/Kpi/OPEXUGMiningMaintenance",
      chartData : {
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "KPI_M_k_formatter"
      }
    }
  }
}
  
